import {performHttpRequest} from "../http";

export async function getSettings() {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteName + '/settings',
        'GET',
    )
}
